import React from "react";

// INDAR logo rendered as text with crimson ampersand accent.
export function Logo({ variant = "dark", className = "" }) {
  const indarColor = variant === "light" ? "text-white" : "text-slate-900";
  const subColor = variant === "light" ? "text-slate-400" : "text-slate-500";
  return (
    <div className={`flex flex-col leading-none select-none ${className}`} data-testid="indar-logo">
      <span className={`font-display font-extrabold tracking-tight text-xl ${indarColor}`}>Indar</span>
      <span className={`text-[10px] font-semibold uppercase tracking-[0.12em] ${subColor}`}>
        Formazione <span className="text-[#E11D48]">&amp;</span> Sviluppo
      </span>
    </div>
  );
}
